import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=969058a6&scoped=true"
import script from "./TicketItem.vue?vue&type=script&lang=js"
export * from "./TicketItem.vue?vue&type=script&lang=js"
import style0 from "./TicketItem.vue?vue&type=style&index=0&id=969058a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969058a6",
  null
  
)

export default component.exports